var applicationWorkhours = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationWorkhoursCtrl ($scope, $sce, $location, $timeout, userStore, flux, actions) {
        var ctrl = this;
        var message;
        var formData = {};
        ctrl.messages = [];

        function init () {
            ctrl.user = userStore.getUser();
            ctrl.hours = ctrl.user.workhours ? ctrl.user.workhours : 2;
        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Vælg hvor mange timer du kan arbejde om ugen 💪 💦'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                $timeout(function() {
                    $location.path('/din-ansoegning');
                }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.submitWorkhours = function submitWorkhours() {
            formData.workhours = ctrl.hours;
            flux.dispatch(actions.UPDATE_USER, formData);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-workhours.component.html',
};